export const ADD_SALESRETURN_REQUEST = "ADD_SALESRETURN_REQUEST";
export const ADD_SALESRETURN_SUCCESS = "ADD_SALESRETURN_SUCCESS";
export const ADD_SALESRETURN_FAIL = "ADD_SALESRETURN_FAIL";

export const FETCH_SALESRETURN_REQUEST = "FETCH_SALESRETURN_REQUEST";
export const FETCH_SALESRETURN_SUCCESS = "FETCH_SALESRETURN_SUCCESS";
export const FETCH_SALESRETURN_FAIL = "FETCH_SALESRETURN_FAIL";


export const UPDATE_SALESRETURN_STATUS_REQUEST = "UPDATE_SALESRETURN_STATUS_REQUEST";
export const UPDATE_SALESRETURN_STATUS_SUCCESS = "UPDATE_SALESRETURN_STATUS_SUCCESS";
export const UPDATE_SALESRETURN_STATUS_FAIL = "UPDATE_SALESRETURN_STATUS_FAIL";